export default __webpack_public_path__ + "locales/ar-SA/VersionHistory.json?hash=9d6bed40af3c742ec80790412628d822";